import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { environment } from './../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartnumberNaoOriginalService extends ServiceCRUD {

  private baseUrlService: string;
  private httpClient: HttpClient;

  constructor(
    http: HttpClient,
    router: Router,
    protected toastr: ToastrService
  ) {
    super(http, router);
    this.httpClient = http;
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/bi/partnumbers-nao-originais`;
  }

  public buscar(filtros: any): Promise<any> {
    const headers = new HttpHeaders({
      'Authorization': this.getToken(),
      'Content-Type': 'application/json'
    });

    return this.httpClient.post(`${this.getURL()}/listar`, filtros, { headers })
      .toPromise()
      .then(this.tratarRetorno)
      .catch(error => {
        this.tratarErro('Não foi possível carregar Partnumbers Não Originais.', 'Erro', error);
        throw error;
      });
  }

  tratarErro(mensagem: string, titulo: string, error: any) {
    console.error(error);

    let texto: string;

    try {
      texto = error.erro ? mensagem + '\n' + error.erro : mensagem;
    } catch (Exception) {
      texto = mensagem;
    }

    this.toastr.error(texto, titulo, error);

    if (error.status === 401) {
      this.router.navigateByUrl('logout');
    }
  }
}